import { apiV2 } from "./api";

// 删除模版
export const agentDeleteTemplate = async (templateId: string) => {
  const res = await apiV2.delete<unknown>("/agent/delete-template", {
    data: {
      template_id: templateId,
    }
  });
  return res;
};
